import { connectToDatabase } from "based-shared/utils/connect-database";
import { UserProfileModel } from "based-shared/models/UserProfile";

export async function getUserProfile(address: string, network: string) {
  await connectToDatabase();
  const user = await UserProfileModel.findOne({
    "users.address": address,
    "users.network": network,
  });
  return user;
}
